module.exports = __webpack_public_path__ + "img/icon_5_21.974da10e.png";